export default function required(value) {
  // false is also a valid value.
  return value !== undefined && value !== null && value !== '';
}

